enum SearchType {
  PLAYER = 1,
  TRANSACTION = 2,
  PAYCARD = 3,
}

export default SearchType
